module.exports = __webpack_public_path__ + "media/images/graph-board-a8e4d35d87ae948c455a82585c573552.svg";